import { render, staticRenderFns } from "./PerguntasFrequentes.vue?vue&type=template&id=0453a368"
import script from "./PerguntasFrequentes.vue?vue&type=script&lang=js"
export * from "./PerguntasFrequentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports